import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Select, Store } from '@ngxs/store';
import { DeleteUser } from 'src/app/state-management/actions/app.actions';
import { AppState } from 'src/app/state-management/state/app.state';
import { LocalStorage } from 'src/app/utils/storage';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.page.html',
  styleUrls: ['./account-settings.page.scss'],
})
export class AccountSettingsPage implements OnInit {
  @Select(AppState.getShowSpinner) showSpinner$;
  public email: string;
  constructor(
    private modalController: ModalController,
    private storageService: LocalStorage,
    private alertController: AlertController,
    private store: Store,
  ) { }

  ngOnInit() {
    let userData = this.storageService.getValue('netqSystems-userData');
    this.email = userData.email;

  }

  async onChangePassword() {
    console.log('onChangePassword');
    // const modal = await this.modalController.create({
    //   component: DeviceDataComponent,
    //   cssClass: 'graph-modal',
    //   swipeToClose: false,
    //   // initialBreakpoint: 1,
    //   // breakpoints: [0, 1],
    //   presentingElement: this.routerOutlet.parentOutlet.nativeEl
    // });
  }


  async onRemoveAccount() {
    const alert = await this.alertController.create({
      header: 'Delete User Account?',
      message: 'You are about to delete your account.  This action cannot be undone!  Please contact <br><a href="mailto:helpdesk@apex-innovation.co.za">helpdesk@apex-innovation.co.za</a> <br>for any funds still linked in your wallet.',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            this.onConfirmRemoveAccount();
          },
        },
      ],
    });

    await alert.present();
  }

  async onConfirmRemoveAccount() {
    const alert = await this.alertController.create({
      header: 'Confirm Delete Account?',
      message: 'Are you sure you want to delete your account? <br>This action cannot be undone!',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            this.store.dispatch(new DeleteUser(true));
          },
        },
      ],
    });

    await alert.present();
  }

}

